import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';

export const CustomXPFieldsHeader = styled.h2`
  color: ${fromTheme('color_text')};
  font-size: ${fromTheme('font_size_heading_4')};
  font-weight: ${fromTheme('font_weight_bolder')};
  margin: 0;
`;

export const CustomXPFieldsContent = styled.div`
  margin-top: ${fromTheme('spacing_medium')};
`;
